const $ = window.$;

$(document).ready(function () {
    $(document).on("click", ".favorite-product", function () {
        var productid = $(this).attr("data-product-id");
        var favorite = $(".icon-heart-" + productid).attr("data-icon-color") == "white" ? true : false;
        $.ajax({
            url: "/favorite/product",
            type: "POST",
            data: {
                productID: productid,
                favoriteProduct: favorite
            },
            success: function (result) {
                if (favorite) {
                    $(".icon-heart-" + productid).attr("src", "/images/heart-red.svg");
                    $(".icon-heart-" + productid).attr("data-icon-color", "red");
                }
                else {
                    $(".icon-heart-" + productid).attr("src", "/images/heart-white.svg");
                    $(".icon-heart-" + productid).attr("data-icon-color", "white");
                }
            }
        });
    });
});
